import React from "react";
import { Clock, IndianRupee, Package, ShoppingBag } from "lucide-react";
import { formatINR } from "../../lib/utils-cynos";

const AdminStats = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-8" data-testid="admin-stats">
      <Stat icon={ShoppingBag} label="Orders" value={stats.total_orders} />
      <Stat icon={Clock} label="Pending" value={stats.pending_orders} accent />
      <Stat icon={Package} label="Products" value={stats.total_products} />
      <Stat icon={IndianRupee} label="Revenue" value={formatINR(stats.revenue)} />
    </div>
  );
};

const Stat = ({ icon: Icon, label, value, accent }) => (
  <div className={`bg-cynos-card border p-5 ${accent ? "border-cynos-red/40" : "border-white/10"}`}>
    <div className="flex items-center justify-between">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">{label}</span>
      <Icon size={16} className={accent ? "text-cynos-red" : "text-zinc-500"} />
    </div>
    <div className="font-anton text-3xl mt-2">{value}</div>
  </div>
);

export default AdminStats;
